import React from 'react'

const BonusClaimed = () => {
  return (
    <div>BonusClaimed</div>
  )
}

export default BonusClaimed